import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { getFoundationDataContext } from '../app/bootstrap-foundation';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';
import { isEmptyOrBlankString } from '@philips-internal/oswald-ui-utils';

export interface AccountSeetings {
  isCaptchaEnable: boolean
}

interface CapchaResponse {
  captchaKey?: string;
}

export async function getCatpchaPublicKey(): Promise<string> {
  try {
    const foundationContext = getFoundationDataContext();
    const response = await HttpService.get<CapchaResponse>(APPLICATION_ENDPOINTS.GET_CAPTCHA_KEY_CONFIGURATION);
    if(isEmptyOrBlankString(response.body?.captchaKey)) {
      const publicKey = foundationContext.get('applicationCaptchaPublicKey') as string;
      return Promise.resolve(publicKey);
    }
    foundationContext.set({ applicationCaptchaPublicKey: response.body?.captchaKey });
    return response.body?.captchaKey as string;
  } catch(error) {
    throw new Error('Failed to get captcha public key');
  }
}